module.exports = __webpack_public_path__ + "assets/images/wegc8c51c8cf42b26eaeb09e435bd52cd56.svg";